import IPage from "../../../interfaces/page"
import RoomFormComponent from "../../Components/RoomForm/RoomForm.component"
import MainLayout from "../../layouts/Main/Main.layout"


const RoomFormPage: React.FC<IPage> = () => {
    return <MainLayout component={RoomFormComponent}></MainLayout>
}

export default RoomFormPage